import React, { Fragment } from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import { FaWhatsapp, FaEnvelope } from "react-icons/fa";
import { FaXTwitter, FaTiktok } from "react-icons/fa6"; // Twitter (X) et TikTok

const Footer = () => {
  return (
    <Fragment>
      <footer className="bg-blue-800 text-gray-300 py-12 px-6 md:px-20">
        {/* Grille en 3 colonnes */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 text-center md:text-left">
          
          {/* À propos */}
          <div>
            <h3 className="text-white text-lg text-center font-semibold mb-3">À propos</h3>
            <p className="text-sm text-center leading-relaxed">
              Ce site a été conçu pour offrir une expérience fluide et moderne dans vos achats en ligne. 
              Développé et maintenu par <span className="font-semibold">
                <a
                  href="https://senegalsite.vercel.app"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-yellow-700 hover:text-yellow-500 focus-visible:ring-2 focus-visible:ring-yellow-500 rounded-sm outline-none transition"
                  aria-label="Ouvrir le site WebAura dans un nouvel onglet"
                >
                  WebAura
                </a>
              </span>. Startup IT spécialisée dans le développement de solutions web et mobiles sécurisées.
            </p>
          </div>

          {/* Liens rapides */}
          <div>
            <h3 className="text-white text-lg text-center font-semibold mb-3">Navigation</h3>
            <ul className="space-y-2 text-sm text-center">
              <li>
                <Link
                  to="/"
                  className="hover:text-white focus-visible:ring-2 focus-visible:ring-white rounded-sm outline-none transition"
                >
                  Accueil
                </Link>
              </li>
              <li>
                <a
                  href="/#shop"
                  className="hover:text-white focus-visible:ring-2 focus-visible:ring-white rounded-sm outline-none transition"
                >
                  Shop
                </a>
              </li>
              <li>
                <Link
                  to="/contact-us"
                  className="hover:text-white focus-visible:ring-2 focus-visible:ring-white rounded-sm outline-none transition"
                >
                  Contact
                </Link>
              </li>
              <li>
                <Link
                  to="/terms"
                  className="hover:text-white focus-visible:ring-2 focus-visible:ring-white rounded-sm outline-none transition"
                >
                  Conditions d'utilisation
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy"
                  className="hover:text-white focus-visible:ring-2 focus-visible:ring-white rounded-sm outline-none transition"
                >
                  Politique de confidentialité
                </Link>
              </li>
            </ul>
          </div>

          {/* Réseaux sociaux */}
          <div>
            <h3 className="text-white text-lg font-semibold mb-3 text-center">Me contacter</h3>
            <div className="flex justify-center space-x-6 mt-3 text-2xl">
              <a
                href="mailto:diamadiaw08@gmail.com"
                className="hover:text-orange-400 focus-visible:ring-2 focus-visible:ring-orange-400 rounded-sm outline-none transition"
                aria-label="M'envoyer un email"
              >
                <FaEnvelope />
              </a>
              <a
                href="https://wa.me/221777336109"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-green-400 focus-visible:ring-2 focus-visible:ring-green-400 rounded-sm outline-none transition"
                aria-label="Me contacter sur WhatsApp"
              >
                <FaWhatsapp />
              </a>
              <a
                href="https://twitter.com/jamaaal_d"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-white focus-visible:ring-2 focus-visible:ring-white rounded-sm outline-none transition"
                aria-label="Me suivre sur X (Twitter)"
              >
                <FaXTwitter />
              </a>
              <a
                href="https://www.tiktok.com/@jamaaal_d"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-pink-500 focus-visible:ring-2 focus-visible:ring-pink-500 rounded-sm outline-none transition"
                aria-label="Me suivre sur TikTok"
              >
                <FaTiktok />
              </a>
            </div>
          </div>
        </div>

        {/* Ligne copyright */}
        <div className="border-t border-gray-700 mt-8 pt-4 text-center text-sm">
          © {moment().format("YYYY")} {""}
          <a
            href="https://webaura.dev"
            target="_blank"
            rel="noopener noreferrer"
            className="font-semibold text-white hover:underline focus-visible:ring-2 focus-visible:ring-white rounded-sm outline-none"
            aria-label="Visiter WebAura dans un nouvel onglet"
          >
            WebAura
          </a>
          . Tous droits réservés.
        </div>
      </footer>
    </Fragment>
  );
};

export default Footer;
